export const themeTokens = {
  light: {
    burntBanksia: {
      '--mudo-bg': 'rgba(255,255,255,0.60)',
      '--mudo-bg-soft': 'rgba(255,255,255,0.70)',
      '--mudo-card': 'rgba(255,255,255,0.72)',
      '--mudo-panel': 'rgba(255,255,255,0.75)',
      '--mudo-text': '#222222',
      '--mudo-text-muted': '#555555',
      '--mudo-border': 'rgba(0,0,0,0.10)',
      '--mudo-shadow': '0 6px 24px rgba(0,0,0,0.12)',
      '--mudo-glass-overlay': 'rgba(255,255,255,0.18)',
      '--mudo-primary': '#c75c2d',
      '--mudo-primary-soft': '#f2d6c4',
      '--mudo-onPrimary': '#0d1014',
    },
    redEarth: {
      '--mudo-bg': 'rgba(255,255,255,0.60)',
      '--mudo-bg-soft': 'rgba(255,255,255,0.70)',
      '--mudo-card': 'rgba(255,255,255,0.72)',
      '--mudo-panel': 'rgba(255,255,255,0.75)',
      '--mudo-text': '#222222',
      '--mudo-text-muted': '#555555',
      '--mudo-border': 'rgba(0,0,0,0.10)',
      '--mudo-shadow': '0 6px 24px rgba(0,0,0,0.12)',
      '--mudo-glass-overlay': 'rgba(255,255,255,0.18)',
      '--mudo-primary': '#b34a3a',
      '--mudo-primary-soft': '#f0cbc3',
      '--mudo-onPrimary': '#0d1014',
    },
    stormyGum: {
      '--mudo-bg': 'rgba(255,255,255,0.60)',
      '--mudo-bg-soft': 'rgba(255,255,255,0.70)',
      '--mudo-card': 'rgba(255,255,255,0.72)',
      '--mudo-panel': 'rgba(255,255,255,0.75)',
      '--mudo-text': '#222222',
      '--mudo-text-muted': '#555555',
      '--mudo-border': 'rgba(0,0,0,0.10)',
      '--mudo-shadow': '0 6px 24px rgba(0,0,0,0.12)',
      '--mudo-glass-overlay': 'rgba(255,255,255,0.18)',
      '--mudo-primary': '#3f757f',
      '--mudo-primary-soft': '#cfe0e3',
      '--mudo-onPrimary': '#0d1014',
    },
  },
  dark: {
    burntBanksia: {
      '--mudo-bg': '#0d1116',
      '--mudo-bg-soft': 'rgba(26, 32, 38, 0.82)',
      '--mudo-text': '#e4e8ec',
      '--mudo-text-muted': '#99a3af',
      '--mudo-border': 'rgba(255, 255, 255, 0.1)',
      '--mudo-primary': '#c75c2d',
      '--mudo-primary-soft': '#2c1f19',
      '--mudo-onPrimary': '#fdf7f0',
    },
    redEarth: {
      '--mudo-bg': '#0d1116',
      '--mudo-bg-soft': 'rgba(26, 32, 38, 0.82)',
      '--mudo-text': '#e4e8ec',
      '--mudo-text-muted': '#99a3af',
      '--mudo-border': 'rgba(255, 255, 255, 0.1)',
      '--mudo-primary': '#b34a3a',
      '--mudo-primary-soft': '#2a1c19',
      '--mudo-onPrimary': '#fdf7f0',
    },
    stormyGum: {
      '--mudo-bg': '#0d1116',
      '--mudo-bg-soft': 'rgba(26, 32, 38, 0.82)',
      '--mudo-text': '#e4e8ec',
      '--mudo-text-muted': '#99a3af',
      '--mudo-border': 'rgba(255, 255, 255, 0.1)',
      '--mudo-primary': '#4a8792',
      '--mudo-primary-soft': '#1f2b30',
      '--mudo-onPrimary': '#fdf7f0',
    },
  },
};

export function getThemeVars(mode = 'light', accent = 'burntBanksia') {
  const byMode = themeTokens[mode] || themeTokens.light;
  const vars = byMode?.[accent] || byMode?.burntBanksia || {};
  return vars;
}
